export const GridPageStripDesignType = {
    TOP_10: 'top_10',
    HORIZONTAL_SINGLE_ROW: 'horizontal_single_row',
    LANDSCAPE_MULTI_ROW: 'landscape_multi_row',
    LANDSCAPE_SINGLE_ROW: 'landscape_single_row',
    WIDE_SINGLE_ROW: 'wide_single_row',
    HORIZONTAL_MIX: 'horizontal_mix',
    INTERACTIVE_GAME_CARDS: 'interactive_game_cards',
};
